import React from 'react';
import ReactDOM from 'react-dom/client';
import {  BrowserRouter as Router,  Routes,  Route} from "react-router-dom";
import Home from './Home';
import Register from './Register';
import Single from './Single';
import Services from './Services';
import About from './About';
import Contact from './Contact';
import $ from 'jquery';
import abgrcs_config from './abgrcs_config.js';

const abgrcs_content = ReactDOM.createRoot(document.getElementById('abgrcs_content'));

/* service list */
var abgrcs_nav_header = new Array();

for (let index = 0; index < abgrcs_config.service_array.length; index++) {
  abgrcs_nav_header.push(
    <>
      <li><a href="#">{abgrcs_config.service_array[index].single_name}</a></li>
    </>
  );
}

var abgrcs_nav_header = (
  abgrcs_nav_header
);

/* service list */


abgrcs_content.render(
  <>
      <div class="site-mobile-menu">
    <div class="site-mobile-menu-header">
      <div class="site-mobile-menu-close mt-3">
        <span class="icon-close2 js-menu-toggle"></span>
      </div>
    </div>
    <div class="site-mobile-menu-body">
      <ul class="site-nav-wrap">
        <li class="active">
          <a href="/">Home</a>
        </li>
        <li class="has-children">
          <span class="arrow-collapse collapsed" data-toggle="collapse" data-target="#collapseItem0"></span>
          <a href="single">Gallery</a>
          <ul class="collapse" id="collapseItem0">
            {abgrcs_nav_header}
          </ul>
        </li>
        <li><a href="services">Services</a></li>
        <li><a href="about">About</a></li>
        <li><a href="contact">Contact</a></li>
      </ul>
      <ul class="site-nav-wrap" data-class="social">
        <li>
          <a href="#" class="pl-0 pr-3"><span class="icon-facebook"></span></a>
        </li>
        <li>
          <a href="#" class="pl-3 pr-3"><span class="icon-twitter"></span></a>
        </li>
        <li>
          <a href="#" class="pl-3 pr-3"><span class="icon-instagram"></span></a>
        </li>
        <li>
          <a href="#" class="pl-3 pr-3"><span class="icon-youtube-play"></span></a>
        </li>
      </ul>
    </div>
  </div>
  <header class="site-navbar py-3" role="banner">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-6 col-xl-3 aos-init aos-animate" data-aos="fade-down">
          <h1 class="mb-0"><a href="/" class=""><img src="uploads/logo.png" alt="Aden PSAILIA" width="200px" /></a></h1>
        </div>
        <div class="col-10 col-md-7 d-none d-xl-block aos-init aos-animate" data-aos="fade-down">
          <nav class="site-navigation position-relative text-right text-lg-center" role="navigation">
            <ul class="site-menu js-clone-nav mx-auto d-none d-lg-block">
              <li class="active"><a href="/">Home</a></li>
              <li class="has-children">
                <a href="single">Gallery</a>
                <ul class="dropdown">
                  {abgrcs_nav_header}
                </ul>
              </li>
              <li><a href="services">Services</a></li>
              <li><a href="about">About</a></li>
              <li><a href="contact">Contact</a></li>
            </ul>
          </nav>
        </div>
        <div class="col-6 col-xl-2 text-right aos-init aos-animate" data-aos="fade-down">
          <div class="d-none d-xl-inline-block">
            <ul class="site-menu js-clone-nav ml-auto list-unstyled d-flex text-right mb-0" data-class="social">
              <li>
                <a href="#" class="pl-0 pr-3"><span class="icon-linkedin"></span></a>
              </li>
              <li>
                <a href="#" class="pl-3 pr-3"><span class="icon-instagram"></span></a>
              </li>
              <li>
                <a href="#" class="pl-3 pr-3"><span class="icon-youtube-play"></span></a>
              </li>
            </ul>
          </div>
          <div class="d-inline-block d-xl-none ml-md-0 mr-auto py-3" style={{"position":"relative", "top":"3px"}}><a href="#" class="site-menu-toggle js-menu-toggle text-black"><span class="icon-menu h3"></span></a></div>
        </div>
      </div>
    </div>
  </header>
  <div id="abgrcs_root" class="container-fluid aos-init aos-animate" data-aos="fade" data-aos-delay="500">
    <React.StrictMode>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route exact path='/single/' element={<Single />} />
          <Route exact path='/single/:id' element={<Single />} />
          <Route exact path='/services' element={<Services />} />
          <Route exact path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route exact path='*' element={<Home />} />
          <Route exact path='/admin/' element={<Home />}>
            <Route path='/admin/:id' element={<Services />} />
          </Route>
        </Routes>
      </Router>
    </React.StrictMode>
  </div>
  <div class="footer py-4">
    <div class="container-fluid text-center">
      <p>
      Copyright ©<script>document.write(new Date().getFullYear());</script> All rights reserved | This template is made by <a href="https://abdellahghrici.web.app/" target="_blank">GHRICI Abdellah</a>
      </p>
    </div>
  </div>
  </>
);

/*
$.post(abgrcs_config.site_url  + "/get_static.php?function=check_login&salt=" + abgrcs_config.getCookie("abgrcs_admin_login"), function(abgrcs_data){
  var result = JSON.parse(abgrcs_data);
  if( result.mission_status == "true" )
  {
    abgrcs_config.user_inf = result.mission_msg;
    const root = ReactDOM.createRoot(document.getElementById('abgrcs_root'));
    const menu_root = ReactDOM.createRoot(document.getElementById('menu_root'));

    root.render(
      <React.StrictMode>
        <Router>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/home' element={<Home />} />
            <Route exact path='/single/:id' element={<Single />} />
            <Route exact path='/services' element={<Services />} />
            <Route exact path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route exact path='*' element={<Home />} />
          </Routes>
        </Router>
      </React.StrictMode>
    );

    menu_root.render(
      <React.StrictMode>
        <HeaderMenuHeader />
      </React.StrictMode>
    );
  }
  else
  {
    
  }
});
*/